import { render, staticRenderFns } from "./IconVimeoPlus.vue?vue&type=template&id=045362a8&"
import script from "./IconVimeoPlus.vue?vue&type=script&lang=js&"
export * from "./IconVimeoPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045362a8')) {
      api.createRecord('045362a8', component.options)
    } else {
      api.reload('045362a8', component.options)
    }
    module.hot.accept("./IconVimeoPlus.vue?vue&type=template&id=045362a8&", function () {
      api.rerender('045362a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVimeoPlus.vue"
export default component.exports